import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {fetchUser, onSaveUser, onDeleteUser} from '../actions/UserActions';
import isEmpty from 'lodash/isEmpty';
import Error from '../components/Error';
import Loading from '../components/Loading';
import EditUser from '../components/UserEdit';

@connect(state => ({users: state.users}), {fetchUser, onSaveUser, onDeleteUser})
export default class UserEditContainer extends Component {
    static propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string
            })
        }),
        users: PropTypes.object,
        fetchUser: PropTypes.func,
        onSaveUser: PropTypes.func,
        onDeleteUser: PropTypes.func,
        history: PropTypes.object,
    };

    componentDidMount() {
        const {match: {params: {id}}} = this.props;
        if (id) {
            this.props.fetchUser(id);
        }
    }

    render() {
        const {users, match: {params: {id}}, history} = this.props;
        const user = users[id] || {};
        if (!isEmpty(user.error)) {
            return <Error error={user.error}/>;
        }
        if (user.loading) {
            return <Loading/>;
        }
        const data = !id ? {} : user;
        return (
            <div className="page">
                <div className="page_contents">
                    <h1>{'User'}</h1>
                    <div className="card" style={{minHeight: 600}}>
                        <EditUser
                            initialValues={data}
                            history={history}
                            userId={id}
                            onSubmit={this.props.onSaveUser}
                            onDeleteUser={this.props.onDeleteUser}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/UserEditContainer.js